import type { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { TPO_DELETE_PROMO_MODAL } from '../../../config/testIds';
import useDeletePromoMutation from '../hooks/useDeletePromoMutation';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';

const antIconDanger = <LoadingOutlined style={{ fontSize: 16, color: 'red' }} spin />;

export interface DeletePromoModalProps {
    open: boolean;
    onClose: () => void;
    promoId: string | null;
    promoName: string | undefined;
    eventId: string;
    onSuccess?: (deletedPromoId: string) => void;
}

const DeletePromoModal: FC<DeletePromoModalProps> = ({ open, onClose, promoId, promoName, eventId, onSuccess }) => {
    const tpoGenConfig = useTpoGenConfig();
    const { mutate: deletePromo, isPending } = useDeletePromoMutation({
        eventId,
        onSuccess: (deletedPromoId: string) => {
            onSuccess?.(deletedPromoId);
            onClose();
        },
    });

    const title = promoName
        ? `Are you sure you want to delete the promotion "${promoName}"?`
        : 'Are you sure you want to delete this promotion?';

    return (
        <ConfirmationModal
            data-testid={TPO_DELETE_PROMO_MODAL}
            open={open}
            okText={isPending ? <Spin indicator={antIconDanger} /> : tpoGenConfig.labels.common.delete}
            cancelText={tpoGenConfig.labels.common.cancel}
            loading={isPending}
            closable={false}
            maskClosable={false}
            okButtonProps={{ type: 'ghost', danger: true, style: { borderRadius: 6 } }}
            onSubmitClick={() => {
                if (promoId) deletePromo(promoId);
            }}
            onCancel={onClose}
            title={title}
            subTitle={tpoGenConfig.labels.modals.deletePromoSubTitle}
            description=""
            width={520}
        />
    );
};

DeletePromoModal.displayName = 'DeletePromoModal';
export default DeletePromoModal;
